module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkin-google-map -with-bg",
    attrs: {
      "name": "hres6oe-work-place"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lastCheckIn.dtework !== ''),
      expression: "lastCheckIn.dtework !== ''"
    }],
    staticClass: "alert alert-last-checkin animated fadeIn"
  }, [_c('div', {
    staticClass: "alert-content"
  }, [_c('div', {
    staticClass: "header clearfix",
    on: {
      "click": function($event) {
        _vm.toggleNotiDetail()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-map-marker"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.lastCheckIn.flg_inout === 'I' ? 'LAST CHECK IN TIME' : 'LAST CHECK OUT TIME') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          " + _vm._s(_vm.lastCheckIn.flg_inout === 'I' ? _vm.setDateOutput(_vm.lastCheckIn.dtein) + ' ' + _vm.lastCheckIn.timin : _vm.setDateOutput(_vm.lastCheckIn.dteout) + ' ' + _vm.lastCheckIn.timout) + "\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dispNotiDetail),
      expression: "dispNotiDetail"
    }],
    staticClass: "body clearfix"
  }, [_c('div', {
    staticClass: "place"
  }, [_vm._v(_vm._s(_vm.lastCheckIn.namcust))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.lastCheckIn.address))])])])]), _vm._v(" "), _c('div', {
    staticClass: "nearby-location animated fadeIn"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flgIsCheckin),
      expression: "flgIsCheckin"
    }]
  }, [_c('div', {
    staticClass: "search-place",
    class: [_vm.dispNearByDropdown ? 'open-dropdown' : ''],
    on: {
      "click": function($event) {
        _vm.toggleNearByDropdown()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "building-detail"
  }, [_c('div', {
    staticClass: "building-name"
  }, [_vm._v("\n            " + _vm._s(_vm.label['HRES6OEC1']['40']) + "\n          ")])]), _vm._v(" "), _c('i', {
    staticClass: "fa icon-select",
    class: [_vm.dispNearByDropdown ? 'fa-angle-up' : 'fa-angle-down'],
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dispNearByDropdown && _vm.nearByDropdownLoading),
      expression: "dispNearByDropdown && nearByDropdownLoading"
    }],
    staticClass: "nearby-place-box"
  }, [_vm._m(1)]), _vm._v(" "), (_vm.dispNearByDropdown && !_vm.nearByDropdownLoading) ? _c('div', {
    staticClass: "nearby-place-box",
    attrs: {
      "id": "nearby-place-box"
    }
  }, _vm._l((_vm.workPlace), function(place, placeIndex) {
    return _c('div', {
      key: placeIndex,
      staticClass: "select-place",
      on: {
        "click": function($event) {
          _vm.callCheckIn(placeIndex)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "building-detail"
    }, [_c('div', {
      staticClass: "building-name"
    }, [_vm._v("\n              " + _vm._s(place.codcust) + " " + _vm._s(place.namcust) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "building-location"
    }, [_vm._v("\n              " + _vm._s(place.address) + "\n            ")])])])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "coordinates-box animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 col-ms-4 col-sm-4 align-center"
  }, [_c('i', {
    staticClass: "ion-navigate arrow-icon fa-3x cursor-pointer",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.callLocation()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-ms-8 col-sm-8"
  }, [_c('div', {
    staticClass: "coordinatesdetail-group"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "label-box"
  }, [_c('div', [_vm._v(_vm._s(_vm.label['HRES6OEC1']['10']) + " :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.label['HRES6OEC1']['20']) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "data-box"
  }, [_c('div', [_vm._v(_vm._s(_vm.center.lat))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.center.lng))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-small"
  }, [_vm._v("In a radius of no more than " + _vm._s(_vm.center.accuracy) + " km.")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "map-panelmenu"
  }, [_c('div', {
    staticClass: "menu-box",
    on: {
      "click": function($event) {
        _vm.callHistory()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o _text-blue",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("History\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-box",
    class: _vm.center.lat === 0 ? '_text-grey' : '',
    on: {
      "click": function($event) {
        _vm.callCheckIn(-1)
      }
    }
  }, [_c('i', {
    staticClass: "ion-ios-location",
    class: _vm.center.lat === 0 ? '_text-grey' : '_text-red',
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flgIsCheckin),
      expression: "flgIsCheckin"
    }]
  }, [_vm._v("Check In")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flgIsCheckin),
      expression: "!flgIsCheckin"
    }]
  }, [_vm._v("Check Out")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-icon -no-border"
  }, [_c('i', {
    staticClass: "fa fa-map-marker -icon-building _text-red"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-place align-center"
  }, [_c('div', {
    staticClass: "infinite-loading-container"
  }, [_c('i', {
    staticClass: "loading-wave-dots"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-icon -no-border"
  }, [_c('i', {
    staticClass: "fa fa-building -icon-building"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-096f5658!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6oe/workPlace.vue
// module id = 3525
// module chunks = 1